
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"33.929","height":"33.929","viewBox":"0 0 33.929 33.929"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#090A0A","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","data-name":"vuesax/twotone/eye-slash"}},[_c('path',{attrs:{"d":"M20.541 13.387l-7.154 7.154a5.059 5.059 0 117.154-7.154z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M25.192 8.157a13.616 13.616 0 00-8.228-2.884c-4.99 0-9.641 2.94-12.879 8.03a7.529 7.529 0 000 7.337 20.253 20.253 0 003.831 4.481"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.903 27.611a13.027 13.027 0 005.061 1.046c4.99 0 9.641-2.94 12.879-8.03a7.529 7.529 0 000-7.337 22.932 22.932 0 00-1.499-2.079M21.927 17.954a5.039 5.039 0 01-3.987 3.987","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M13.387 20.541l-10.56 10.56M31.101 2.827l-10.56 10.56"}})])])
          )
        }
      }
    